import { useLocation } from 'react-router';

export default useLocation;
